import { Github, Twitter, MessageSquare } from 'lucide-react'

export function Footer() {
  return (
    <footer className="border-t border-foreground/10 py-12 bg-foreground/2">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <h3 className="text-xl font-semibold mb-4">tchmpp</h3>
            <p className="text-sm text-foreground/60 mb-4">
              MPP Payment Gateway on ThaiChain — enabling seamless machine-to-machine payments
              for AI agents and applications.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://github.com/thaichain"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/60 hover:text-foreground transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com/thaichain"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/60 hover:text-foreground transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://discord.gg/thaichain"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/60 hover:text-foreground transition-colors"
              >
                <MessageSquare className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm text-foreground/60">
              <li>
                <a href="#features" className="hover:text-foreground transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="hover:text-foreground transition-colors">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#tools" className="hover:text-foreground transition-colors">
                  Tools
                </a>
              </li>
              <li>
                <a href="#getting-started" className="hover:text-foreground transition-colors">
                  Getting Started
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm text-foreground/60">
              <li>
                <a href="https://mpp.thaichain.org/openapi.json" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
                  API Docs
                </a>
              </li>
              <li>
                <a href="https://mpp.thaichain.org/SKILL.md" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
                  Skill Guide
                </a>
              </li>
              <li>
                <a href="https://www.npmjs.com/package/tchcash" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
                  tchcash on npm
                </a>
              </li>
              <li>
                <a href="https://exp.thaichain.org" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
                  ThaiChain Explorer
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-foreground/10 text-center text-sm text-foreground/40">
          <p>© 2026 ThaiChain. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
